import { Injectable, Inject, PLATFORM_ID, Optional } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TransferState, makeStateKey } from '@angular/platform-browser';

const IS_MOBILE_KEY = makeStateKey<boolean>('isMobile');

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectService {
  private isMobile: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private transferState: TransferState,
    @Optional() @Inject('IS_MOBILE') private serverIsMobile?: boolean
  ) {
    if (isPlatformBrowser(this.platformId)) {
      // Check for mobile override in URL
      const urlParams = new URLSearchParams(window.location.search);
      const mobileOverride = urlParams.get('mobile') === '1';
      
      if (mobileOverride) {
        this.isMobile = true;
        this.transferState.set(IS_MOBILE_KEY, true);
      } else {
        // Try to get from TransferState (SSR)
        const serverIsMobile = this.transferState.get<boolean | null>(IS_MOBILE_KEY, null);
        if (serverIsMobile !== null) {
          this.isMobile = serverIsMobile;
        } else {
          // Client-side detection
          this.isMobile = this.detectMobile();
          this.transferState.set(IS_MOBILE_KEY, this.isMobile);
        }
      }
    } else {
      // Server-side: use provided value or default
      this.isMobile = this.serverIsMobile ?? false;
      this.transferState.set(IS_MOBILE_KEY, this.isMobile);
    }
  }

  getIsMobile(): boolean {
    return this.isMobile;
  }

  private detectMobile(): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileRegex.test(userAgent);
  }
}

